import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, realTimeBaseURL } from '../../../../Containers/Config/index.js';
import { GET_GOLF_COURSE, GET_GOLF_COURSE_SUCCESS, GET_GOLF_COURSE_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getGolfCourses({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${realTimeBaseURL}/admin/golfcourses`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        pageIndex: payload?.urlParam?.pageIndex,
        pageSize: Constant?.TABLE_PAGE_SIZE,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_GOLF_COURSE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_GOLF_COURSE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_GOLF_COURSE_ERROR, payload: error });
  }
}

export function* watchGetGolfCourses() {
  yield takeEvery(GET_GOLF_COURSE, getGolfCourses);
}

function* getGolfCoursesSaga() {
  yield all([fork(watchGetGolfCourses)]);
}

export default getGolfCoursesSaga;
